import { CmsObjectWithDefault } from '@components/Cms/types';

export type EmailOtpEntryFormCmsKey = 'Title' | 'EmailLabel' | 'InvalidEmail' | 'SendOtpButtonText' | 'ErrorMessage';

export const EmailOtpEntryFormCmsWithDefault: CmsObjectWithDefault<EmailOtpEntryFormCmsKey> = {
    Title: {
        cmsId: 558089,
        defaultTranslation: 'Enter email',
    },
    EmailLabel: {
        cmsId: 67374,
        defaultTranslation: 'Email',
    },
    InvalidEmail: {
        cmsId: 331873,
        defaultTranslation: 'Enter a valid email id.',
    },
    SendOtpButtonText: {
        cmsId: 558088,
        defaultTranslation: 'Send OTP',
    },
    ErrorMessage: {
        cmsId: 188020,
        defaultTranslation: 'Something went wrong. Please try again.',
    },
};
